<div
  class="ob-modal"
  [class.ob-modal--static]="prefersReducedMotion"
  [class.ob-modal--anchored]="!!pointerSide"
  [class.ob-modal--pointer-top]="pointerSide === 'top'"
  [class.ob-modal--pointer-bottom]="pointerSide === 'bottom'"
  [class.ob-modal--pointer-left]="pointerSide === 'left'"
  [class.ob-modal--pointer-right]="pointerSide === 'right'"
  [class.ob-modal--text-compact]="textDensity === 'compact'"
  [class.ob-modal--heading-left]="headingAlign === 'left'"
  [class.ob-modal--responsive-wide]="responsiveWide"
>
  <!-- Anchored-prompt pointer (Figma 20:5582 / 20:6665 "Vector"): one up-pointing shape, rotated
       per side inside the SVG. Shadowed together with the card via .ob-modal--anchored. -->
  <svg
    class="ob-modal__pointer"
    *ngIf="pointerSide"
    [attr.viewBox]="isVerticalPointer ? '0 0 28 21' : '0 0 21 28'"
    [style.left.px]="isVerticalPointer ? pointerOffset : null"
    aria-hidden="true"
    focusable="false"
  >
    <path [attr.transform]="pointerTransform" d="M0 21C2.5 21 3.8 20 4.8 18.6L12.3 1.2C13 -0.4 15 -0.4 15.7 1.2L23.2 18.6C24.2 20 25.5 21 28 21Z" />
  </svg>

  <div class="ob-modal__card" [attr.role]="cardRole" [attr.aria-label]="heading">
    <button
      *ngIf="showClose"
      type="button"
      class="ob-modal__close"
      aria-label="Close"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-close.svg"></svg-icon>
    </button>

    <div class="ob-modal__eyebrow" *ngIf="showEyebrow">
      <svg-icon src="assets/icons/icon-super-stars-mono.svg"></svg-icon>
      <span>Getting started</span>
    </div>

    <!-- tabindex="-1": programmatically focusable, so a centred modal can move focus here on open
         (openOnboardingCentredModal's autoFocus) without adding a tab stop. -->
    <h3 class="ob-modal__heading" tabindex="-1">{{ heading }}</h3>
    <p class="ob-modal__body">{{ bodyPrimary }}</p>

    <ng-container *ngIf="bodySecondary">
      <div class="ob-modal__divider" *ngIf="showDividerBeforeSecondary" aria-hidden="true"></div>
      <p class="ob-modal__body">{{ bodySecondary }}</p>
    </ng-container>

    <div class="ob-modal__footer" *ngIf="hasFooter" [class.ob-modal__footer--link]="secondaryStyle === 'link'">
      <ng-container *ngIf="secondaryStyle === 'pill'">
        <button
          *ngIf="secondaryLabel"
          type="button"
          class="ob-modal__button ob-modal__button--secondary-pill"
          (click)="onSecondary()"
        >
          {{ secondaryLabel }}
        </button>
        <button
          *ngIf="primaryLabel"
          type="button"
          class="ob-modal__button ob-modal__button--primary"
          (click)="onPrimary()"
        >
          {{ primaryLabel }}
        </button>
      </ng-container>

      <ng-container *ngIf="secondaryStyle === 'link'">
        <button
          *ngIf="primaryLabel"
          type="button"
          class="ob-modal__button ob-modal__button--primary ob-modal__button--full"
          (click)="onPrimary()"
        >
          {{ primaryLabel }}
        </button>
        <button
          *ngIf="secondaryLabel"
          type="button"
          class="ob-modal__link"
          (click)="onSecondary()"
        >
          {{ secondaryLabel }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
